module.exports = __webpack_public_path__ + "static/media/hoverTwitter.805f296e.svg";